class APIS {
	apis() {
		return {
			emailAccountLimitSet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-account-limit/set'
			},
			emailAccountLimitGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-account-limit/get'
			},
			emailAccountLimitAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-account-limit/all'
			},
			emailAccountLimitRemove: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-account-limit/remove'
			}
		};
	}
}

export default new APIS();
